module.exports = __webpack_public_path__ + "static/media/neu.172d072d.svg";